import { createProductContextualButton } from './createProductContextualButton';

export function initializeProductContextualButtons() {
    document
        .querySelectorAll<HTMLElement>('[data-bri-product-card]')
        .forEach(parent =>
            createProductContextualButton({
                productId: parent.getAttribute('data-bri-product-id'),
                parent,
                marginRight:
                    parent.getAttribute('data-bri-margin-right') ?? undefined,
                marginTop:
                    parent.getAttribute('data-bri-margin-top') ?? undefined
            })
        );
}
